
import { useState, useEffect } from 'react';

const CAMPAIGN_END = new Date('2026-03-31T23:59:59+09:00');

export default function CampaignCTA() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calc = () => {
      const diff = CAMPAIGN_END.getTime() - Date.now();
      if (diff <= 0) {
        setIsExpired(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    calc();
    const t = setInterval(calc, 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="py-20 sm:py-28 bg-gradient-to-br from-[#FFF5F2] via-[#FFF8F5] to-[#FFFAF7]" aria-labelledby="campaign-cta-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <span className="text-3xl sm:text-4xl mb-4 block" aria-hidden="true">🌸</span>
        <h2 id="campaign-cta-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-4 tracking-[0.08em]">
          この機会をお見逃しなく
        </h2>
        <p className="text-sm sm:text-base font-extralight text-black/50 mb-8 sm:mb-10 tracking-wide max-w-lg mx-auto">
          新生活応援キャンペーンは 2026年3月31日 まで。<br />
          値上げ前の特別価格で MeVER Chair をお求めいただけます。
        </p>

        {/* Mini countdown */}
        {!isExpired && (
          <div className="inline-flex items-center gap-3 bg-white rounded-full px-6 sm:px-8 py-3 sm:py-4 shadow-sm border border-[#E8B4B8]/15 mb-8 sm:mb-10">
            <span className="text-xs sm:text-sm text-black/50 font-light tracking-wide">残り</span>
            <span className="text-lg sm:text-xl font-light text-[#C4787A] tracking-tight">
              {timeLeft.days}日 {String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
        )}

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 py-4 bg-black text-white text-sm sm:text-base font-light tracking-[0.08em] hover:bg-black/80 transition-colors whitespace-nowrap rounded-md cursor-pointer"
          >
            <i className="ri-calendar-check-line text-base" aria-hidden="true"></i>
            予約相談・お問い合わせ
          </a>
          <a
            href="https://mever.design/products/mever-chair-pro"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 py-4 bg-[#C4787A] text-white text-sm sm:text-base font-light tracking-[0.08em] hover:bg-[#B06A6C] transition-colors whitespace-nowrap rounded-md cursor-pointer"
          >
            <i className="ri-shopping-cart-line text-base" aria-hidden="true"></i>
            オンラインショップへ
          </a>
        </div>

        <div className="mt-6">
          <a
            href="https://appointment.mever.design/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-1.5 text-sm font-light text-black/50 hover:text-black transition-colors cursor-pointer tracking-wide"
          >
            <i className="ri-calendar-check-line text-sm" aria-hidden="true"></i>
            まずは体験予約する
          </a>
        </div>
      </div>
    </section>
  );
}
